module.exports = __webpack_public_path__ + "img/akuvox-page_az.e72c6eb3.png";